import { createAction, props } from '@ngrx/store';

export const loadInstances = createAction('[Instance] Load Instances');

export const loadInstancesSuccess = createAction('[Instance] Load Instances Success', props<{ instances: any[] }>());

export const failedLoadingInstances = createAction('[Instance] Load Instances failed');

export const addrandom = createAction('Instance Adding random');
